import PWAPrompt from './PWAPrompt';

const deviceCheck = () => {
  const isiOS = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
  const isiPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const isStandalone = 'standalone' in window.navigator && (window.navigator as any).standalone;

  return (isiOS || isiPadOS) && !isStandalone;
};

const IosPWAPrompt = () => {
  const timesToShow = 5;
  const promptOnVisit = 1;
  const permanentlyHideOnDismiss = true;
  const delay = 1000;
  const debug = false;

  let promptData = JSON.parse(String(localStorage.getItem('iosPwaPrompt')));

  if (promptData === null) {
    promptData = { isiOS: deviceCheck(), visits: 0 };
    localStorage.setItem('iosPwaPrompt', JSON.stringify(promptData));
  }

  if (promptData.isiOS || debug) {
    const aboveMinVisits = promptData.visits + 1 >= promptOnVisit;
    const belowMaxVisits = promptData.visits + 1 < promptOnVisit + timesToShow;

    if ((belowMaxVisits && aboveMinVisits) || debug) {
      return (
        <PWAPrompt
          delay={delay}
          permanentlyHideOnDismiss={permanentlyHideOnDismiss}
          promptData={promptData}
          maxVisits={timesToShow + promptOnVisit}
        />
      );
    }
  }

  return null;
};

export default IosPWAPrompt;